import { FC } from 'react';
import { useIntl } from 'react-intl';

import { paymentTermsTypes } from '@features/rates/PaymentTerms.schema';
import { useTranslations } from '@lang';
import { PaymentTerms } from 'shared-types/Common';

import { Container } from './PaymentTermsBadge.styles';

type PaymentTermsBadgeProps = {
  paymentTerms?: PaymentTerms | null;
  /** Set where the price alongside is a "from" price, so the deposit reads as a from too */
  isFromPrice?: boolean;
};

export const PaymentTermsBadge: FC<PaymentTermsBadgeProps> = ({ paymentTerms, isFromPrice }) => {
  const { t } = useTranslations();
  const intl = useIntl();

  const buildLabel = () => {
    if (paymentTerms?.type === paymentTermsTypes.DEFERRED_FULL) {
      return t('rates.paymentTerms.payLater');
    }

    if (paymentTerms?.type !== paymentTermsTypes.DEFERRED_PARTIAL) {
      return null;
    }

    const { amountDueNow } = paymentTerms;

    if (!amountDueNow?.currencyCode) {
      return t('rates.paymentTerms.depositThenBalance');
    }

    const price = intl.formatNumber(amountDueNow.amount / 100, {
      style: 'currency',
      currency: amountDueNow.currencyCode,
    });

    return t(isFromPrice ? 'rates.paymentTerms.partialFrom' : 'rates.paymentTerms.partial', {
      price,
    });
  };

  const label = buildLabel();

  if (!label) {
    return null;
  }

  return <Container data-testid="payment-terms-badge">{label}</Container>;
};
